import React from "react";
import styles from "./Contact.module.css";
// import { FaLinkedin } from "react-icons/fa";
// import { FaTwitter } from "react-icons/fa";
// import { FaGithub } from "react-icons/fa";
import { FaMugHot, FaTelegramPlane } from "react-icons/fa";
import emailjs from "emailjs-com";
import PageHeader from "../../Utils/PageHeader";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";
const Contact = () => {
  const { mode } = React.useContext(ThemeContext);
  //   const handleGithub = () => {
  //     window.open("https://github.com/hithanos");
  //   };

  //   const handleLinkedin = () => {
  //     window.open("https://www.linkedin.com/in/himanshu-kumar-265981178/");
  //   };

  //   const handleTwitter = () => {
  //     window.open("https://twitter.com/Himansh38508255");
  //   };
  const [message, setData] = React.useState("");
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const handleSubmit = () => {
    setData("");
    setEmail("");
    setName("");
  };
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_5noa569",
        "template_pwf6txn",
        e.target,
        "user_XjPKQG7v0RE7NTO9gcH3C"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    handleSubmit();
  }
  return (
    <div
      id="contact"
      className="parentContainer"
      style={{ marginBottom: "200px" }}
    >
      <PageHeader>Get In Touch.</PageHeader>
      <div className={styles.tagline}>
        I am always excited to work on some awesome projects, message me and
        let's discuss over coffee.&nbsp;
        <FaMugHot />
      </div>
      <div id="contact" className={styles.container}>
        <div
          className={styles.form}
          style={
            mode === "dark"
              ? { backgroundColor: "rgb(35,35,35)" }
              : { backgroundColor: "#fff" }
          }
        >
          <form onSubmit={sendEmail}>
            <div style={{ marginTop: "10px" }}>
              <label htmlFor="">Name</label>
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="John Doe"
                required
              />
            </div>
            <div style={{ marginTop: "30px" }}>
              <label htmlFor="">Email</label>
              <input
                type="email"
                name="email"
                id=""
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="johDoe@gmail.com"
                required
              />
            </div>
            <div style={{ marginTop: "20px" }}>
              <label htmlFor="">Write a message for me below</label>
              <input
                style={{ height: "150px" }}
                type="text"
                value={message}
                name="message"
                onChange={(e) => setData(e.target.value)}
                placeholder="Write your message here ..."
                required
              />
            </div>
            <br />
            <button className={styles.submitButton} type="submit" value="Send">
              <FaTelegramPlane /> Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
